"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var core_1 = require("@material-ui/core");
var react_1 = __importDefault(require("react"));
var styles_1 = require("./styles");
/**
 * Componente HyperLink.
 * Cada propriedade age de um determinado modo e algumas propriedades podem depender de outras.
 * @param {string} title Texto do link.
 * @param {string=} to link/caminho.
 * @param {string} type Tipo do Link.
 */
var HyperLink = function (_a) {
    var to = _a.to, type = _a.type, title = _a.title, rest = __rest(_a, ["to", "type", "title"]);
    return (jsx_runtime_1.jsxs(styles_1.Container, __assign({ className: "hyperLinkStyle" }, { children: [type === 'link' && (jsx_runtime_1.jsxs("a", __assign({}, rest, { href: to }, { children: [title, jsx_runtime_1.jsxs(core_1.SvgIcon, __assign({ viewBox: "0 0 24 24", width: "1.5em", height: "1.5em" }, { children: [jsx_runtime_1.jsx("path", { d: "M12.2266 11.5C12.5027 11.5 12.7266 11.7239 12.7266 12C12.7266 12.2761 12.5027 12.5 12.2266 12.5V11.5ZM2.89741 12.5C2.62127 12.5 2.39741 12.2761 2.39741 12C2.39741 11.7239 2.62127 11.5 2.89741 11.5V12.5ZM12.2266 12.5H2.89741V11.5H12.2266V12.5Z", fill: "#12AAFF" }, void 0),
                            jsx_runtime_1.jsx("path", { d: "M15.352 11.8142L13.5618 10.2023C13.047 9.7388 12.2265 10.1041 12.2265 10.7968V13.2032C12.2265 13.8959 13.047 14.2612 13.5618 13.7977L15.352 12.1858C15.4623 12.0865 15.4623 11.9135 15.352 11.8142Z", fill: "#12AAFF" }, void 0)] }), void 0)] }), void 0)),
            type === 'detail' && (jsx_runtime_1.jsxs("a", __assign({}, rest, { href: to }, { children: [title, jsx_runtime_1.jsxs(core_1.SvgIcon, __assign({ style: { color: 'transparent', width: '18px' }, viewBox: "0 0 20 20", width: "18", height: "18" }, { children: [jsx_runtime_1.jsx("circle", { cx: "8", cy: "8", r: "5", stroke: "#12AAFF", strokeWidth: "2" }, void 0),
                            jsx_runtime_1.jsx("path", { d: "M15 15L12 12", stroke: "#12AAFF", strokeWidth: "2", strokeLinecap: "round" }, void 0)] }), void 0)] }), void 0))] }), void 0));
};
exports.default = react_1.default.memo(HyperLink);
//# sourceMappingURL=index.js.map